"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SectionTitle = exports.SectionHeader = exports.SectionBody = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _ChevronUp = _interopRequireDefault(require("@insided/shared/icons/ChevronUp"));

var SectionTitle = function SectionTitle(_ref) {
  var children = _ref.children;
  return (0, _preact.h)("div", {
    className: "a-section-title"
  }, children);
};

exports.SectionTitle = SectionTitle;

var SectionHeader = function SectionHeader(_ref2) {
  var children = _ref2.children,
      isCollapsed = _ref2.isCollapsed,
      onToggleCollapse = _ref2.onToggleCollapse,
      className = _ref2.className;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)(['m-section-header', isCollapsed && 'm-section-header--collapsed', className])
  }, (0, _preact.h)(SectionTitle, null, children), onToggleCollapse && (0, _preact.h)("span", {
    className: "m-section-header__toggle"
  }, (0, _preact.h)(_Button.default, {
    onClick: onToggleCollapse,
    title: isCollapsed ? (0, _preact.h)(_ChevronDown.default, {
      width: 24,
      height: 24
    }) : (0, _preact.h)(_ChevronUp.default, {
      width: 24,
      height: 24
    }),
    size: "medium"
  })));
};

exports.SectionHeader = SectionHeader;

var SectionBody = function SectionBody(_ref3) {
  var children = _ref3.children,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'primary' : _ref3$variant;
  return (0, _preact.h)("div", {
    className: "m-section-body m-section-body--".concat(variant)
  }, children);
};

exports.SectionBody = SectionBody;

var Section = function Section(_ref4) {
  var title = _ref4.title,
      children = _ref4.children,
      isCollapsed = _ref4.isCollapsed,
      _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? 'primary' : _ref4$variant,
      onToggleCollapse = _ref4.onToggleCollapse,
      className = _ref4.className;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('m-section', "m-section--".concat(variant), className)
  }, (0, _preact.h)(SectionHeader, {
    isCollapsed: isCollapsed,
    onToggleCollapse: onToggleCollapse
  }, title), !isCollapsed && (0, _preact.h)(SectionBody, {
    variant: variant
  }, children));
};

var _default = Section;
exports.default = _default;